module.exports = __webpack_public_path__ + "img/tasty-hemp-gummies.de552fa5.jpg";